import axios from "axios";

// Hybrid auth: primary is httpOnly Secure cookie. Fallback: Bearer token
// stored in sessionStorage so the session survives a page refresh even in
// browsers (Safari) whose CORS enforcement blocks cookies on preflighted
// requests. sessionStorage is cleared on tab close.

export const API = "/api";
const TOKEN_KEY = "tbi_bearer";

let _token = typeof window !== "undefined" ? sessionStorage.getItem(TOKEN_KEY) : null;

export const setAuthToken = (token) => {
  _token = token || null;
  if (typeof window === "undefined") return;
  if (token) sessionStorage.setItem(TOKEN_KEY, token);
  else sessionStorage.removeItem(TOKEN_KEY);
};

export const clearAuthToken = () => setAuthToken(null);
export const getAuthToken = () => _token;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if (_token) {
    config.headers.Authorization = `Bearer ${_token}`;
  }
  return config;
});
